<template>
  <div class="info-wrapper">
    <img class="info-wrapper" :src="textData.img">
    <div ref="move" :class="moveClass">
      <div class="service_p">
        <h2>{{textData.title}}</h2>
        <p class="fnt_24">{{textData.describe}}</p>
      </div>
      <div class="service_content">
        <div class="title">
          <h2>{{contentData.title}}</h2>
          <p class="fnt_24">{{contentData.describe}}</p>
        </div>
        <div class="line">
          <img class="slider" ref="slider" src="../../../static/images/firstPage/slider.png">
        </div>
        <div class="child">
          <div class="fnt_24"><img src="../../../static/images/firstPage/duihao.png">{{contentData.content1}}</div>
          <div class="fnt_24"><img src="../../../static/images/firstPage/duihao.png">{{contentData.content2}}</div>
          <div class="fnt_24"><img src="../../../static/images/firstPage/duihao.png">{{contentData.content3}}</div>
          <div class="fnt_24"><img src="../../../static/images/firstPage/duihao.png">{{contentData.content4}}</div>
          <div>
            <el-button @click="routerTo(contentData.route)">
              了解更多内容
              <i class="el-icon-caret-right el-icon--right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      moveClass: 'data-text move-before',
      textData: {},
      contentData: {}
    }
  },
  methods: {
    routerTo (route) {
      this.$router.push({
        path: route,
        query: ''
      })
    }
  },
  mounted: function () {
    // add by Bo Lau on 2023-03-10
    if (this.$boss) {
      this.textData = this.$boss.page31.g31[0]
      this.contentData = this.$boss.page132.g132[0]
    }
  }
}
</script>
<style scoped lang="less">
  .info-wrapper {
    width: 100%;
    height: 100%;
    /*background: url("../../../static/images/firstPage/operationFlow.png") no-repeat;*/
    background-size: 100% 100%;
  }
  @media screen and (max-width: 1900px) {
    .data-text {
      color: #202122;
      position: absolute;
      left: 200px;
      top: 12%;
      text-align: left;
      width: 100%;
      z-index: 999;
      transition: all 1.5s;
      -webkit-transition: all 1.5s;
    }
    .move-before{
      transform: translate(0,-50%);
      -webkit-transform: translate(0,-50%);
      -ms-transform: translate(0,-50%);
      opacity: 0;

    }

    .move-after{
      transform: translate(-100px,-50%);
      -webkit-transform: translate(-100px,-50%);
      -ms-transform: translate(-100px,-50%);
      opacity: 1;
    }
    .service_p h2, .service_p p {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .service_p p {
      font-size: 24px;
      color: #72899b;
    }
    .service_p h2 {
      font-size: 36px;
      margin-bottom: 15px;
      line-height: 40px;
      max-height: 120px;
    }
    .service_content{
      width: 60%;
      position: absolute;
      left: 20px;
      height: 60vh;
      top: 25vh;
      .title{
        h2 {
          font-size: 24px;
        }
        p {
          font-size: 16px;
          color: #72899b;
        }
      }
      .child{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        min-height: 30vh;
        div {
          width: 100%;
          padding: 10px 0;
          font-size: 16px;
          img {
            padding-right: 10px;
            width: 16px;
            height: 16px;
          }
        }
      }
      .el-button {
        color: #FFFFFF;
        background-color: #fa6e1a;
        border: 1px solid #fa6e1a;
        font-size: 16px;
      }
    }
    .slider {
      position: absolute;
      left: 0px;
    }
    .line {
      width: 100%;
      height: 2px;
      background: url("../../../static/images/firstPage/line.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  @media screen and (min-width: 1901px) {
    .data-text {
      color: #202122;
      position: absolute;
      left: 200px;
      top: 12%;
      text-align: left;
      width: 100%;
      z-index: 999;
      transition: all 1.5s;
      -webkit-transition: all 1.5s;
    }
    .move-before{
      transform: translate(0,-50%);
      -webkit-transform: translate(0,-50%);
      -ms-transform: translate(0,-50%);
      opacity: 0;

    }

    .move-after{
      transform: translate(-100px,-50%);
      -webkit-transform: translate(-100px,-50%);
      -ms-transform: translate(-100px,-50%);
      opacity: 1;
    }
    .service_p h2, .service_p p {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .service_p p {
      font-size: 24px;
      color: #72899b;
    }
    .service_p h2 {
      font-size: 42px;
      margin-bottom: -15px;
      line-height: 60px;
      max-height: 120px;
    }
    .service_content{
      width: 60%;
      position: absolute;
      left: 50px;
      margin-top: 3%;
      .title{
        h2 {
          font-size: 32px;
          font-weight: 500;
        }
        p {
          font-size: 24px;
          color: #72899b;
        }
      }
      .child{
        div {
          padding: 1.2rem 0;
          font-size: 24px;
          img {
            padding-right: 10px;
          }
        }
      }
      .el-button {
        color: #FFFFFF;
        background-color: #fa6e1a;
        border: 1px solid #fa6e1a;
        font-size: 18px;
      }
    }
    .slider {
      position: absolute;
      left: 0px;
    }
    .line {
      width: 100%;
      height: 2px;
      background: url("../../../static/images/firstPage/line.png") no-repeat;
      background-size: 100% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/operationFlow.vue